import { render, staticRenderFns } from "./PoiPage.vue?vue&type=template&id=4922eba6&scoped=true&"
import script from "./PoiPage.vue?vue&type=script&lang=js&"
export * from "./PoiPage.vue?vue&type=script&lang=js&"
import style0 from "./PoiPage.vue?vue&type=style&index=0&id=4922eba6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4922eba6",
  null
  
)

export default component.exports